import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'

import styles from './PromoUsageWarningDialog.module.scss'

const PromoUsageWarningDialog = ({
  promoCode,
  onClose,
  onConfirm,
  showPromoUsageWarning
}) => (
  <ConfirmationDialog
    title={<>{promoCode} is already in use</>}
    onClose={onClose}
    onConfirm={onConfirm}
    positiveMessage="Yes, I want to use it"
    negativeMessage="Go back"
    hasDangerousAction={showPromoUsageWarning === 'hard'}
  >
    {showPromoUsageWarning === 'soft' ? (
      <p className={styles.usageWarningDialogParagraph}>
        The promo code you've entered has been used for previous bookings. To accurately
        track exposed bookings, we encourage you to use a unique code specifically for
        Directful. Exposed bookings may include non-Directful bookings while using this
        code.
      </p>
    ) : showPromoUsageWarning === 'hard' ? (
      <p className={styles.usageWarningDialogParagraph}>
        The promo code you've entered has been used for numerous previous bookings. When
        using this code, exposed bookings will not be tracked. To track exposed bookings,
        please enter a unique code specifically for Directful.
      </p>
    ) : null}

    <p className={styles.usageWarningDialogParagraph}>
      Do you still want to use {promoCode}?
    </p>
  </ConfirmationDialog>
)

export default PromoUsageWarningDialog
